import { render, staticRenderFns } from "./AdminProjectPostAdd.vue?vue&type=template&id=b4632788&"
import script from "./AdminProjectPostAdd.vue?vue&type=script&lang=js&"
export * from "./AdminProjectPostAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports